import checkboxtags from './CheckboxTags.vue'
checkboxtags.install = Vue => Vue.component(checkboxtags.name, checkboxtags)
export default checkboxtags



// WEBPACK FOOTER //
// ./src/packages/checkboxtags/index.js